<template>
  <div id="app">
    <b-navbar toggleable="md" type="dark" variant="info" fixed="top">

      <div class="container-fluid">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand href="#main">LADN</b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">

          <b-navbar-nav>
            <b-nav-item href="#abstract">Paper</b-nav-item>
            <b-nav-item href="#result">Results</b-nav-item>
            <!-- <b-nav-item href="#network">Network</b-nav-item> -->
          </b-navbar-nav>

        </b-collapse>
      </div>

    </b-navbar>

    <div class="jumbotron img-width-auto" id="main">
      <h1>LADN: Local Adversarial Disentangling Network for <br /> Facial Makeup and De-Makeup</h1>
      <br />
      <h4><a href="https://github.com/wangguanzhi/LADN">[Github]</a> <a href="https://arxiv.org/abs/1904.11272">[Paper]</a> <a href="https://drive.google.com/open?id=1gygDQarCOZ7E4qptvTyYF_iZNxsJ4WnI">[Dataset]</a></h4>
      <br />
      <!-- Author -->
      <h5>Qiao Gu<sup>1,4</sup>*, Guanzhi Wang<sup>1,5</sup>*, Mang Tik Chiu<sup>2</sup>, Yu-Wing Tai<sup>3</sup>, Chi-Keung Tang<sup>1</sup></h5>
      <br />
      <h6><sup>1</sup>Hong Kong University of Science and Technology, <sup>2</sup>University of Illinois Urbana-Champaign</h6>
      <h6><sup>3</sup>Tencent, <sup>4</sup>Carnegie Mellon University, <sup>5</sup>Stanford University</h6>
      <br />
      <h6>qiaog@andrew.cmu.edu, guanzhi@stanford.edu, mtchiu2@illinois.edu, yuwingtai@tencent.com, cktang@cs.ust.hk</h6>
      <h6>(*equal contribution)</h6>

      <!-- <center>
        <img src="public/teaser.jpg" style="width:80%"/>
      </center> -->
      <hr />

      <div class="row">

        <div class="col-sm-4 offset-sm-2">
          <div class="row margintd10">
            <div class="col-sm-12">
              <img :src="'public/interpolation/'+teaser_list[0]+'/transfer.gif'"  width="100%"/>
              <h6>Interpolated Makeup Styles</h6>
            </div>
          </div>
          <div class="row margintd10">
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+teaser_list[0]+'/afterA.jpg'"  width="100%"/>
              <h6>Ref 1</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+teaser_list[0]+'/before.jpg'"  width="100%"/>
              <h6>Source</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+teaser_list[0]+'/afterB.jpg'"  width="100%"/>
              <h6>Ref 2</h6>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="row margintd10">
            <div class="col-sm-12">
              <img :src="'public/interpolation/'+teaser_list[1]+'/transfer.gif'"  width="100%"/>
              <h6>Interpolated Makeup Styles</h6>
            </div>
          </div>
          <div class="row margintd10">
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+teaser_list[1]+'/afterA.jpg'"  width="100%"/>
              <h6>Ref 1</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+teaser_list[1]+'/before.jpg'"  width="100%"/>
              <h6>Source</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+teaser_list[1]+'/afterB.jpg'"  width="100%"/>
              <h6>Ref 2</h6>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="jumbotron bg-white" id="abstract">
      <h2>Abstract</h2>

      <div class="row">
        <div class="col-sm-8 offset-sm-2">
          <p class="text-align-left">
            We propose a local adversarial disentangling network (LADN) for facial makeup and de-makeup. Central to our method are multiple and overlapping local adversarial discriminators in a content-style disentangling network for achieving local detail transfer between facial images, with the use of asymmetric loss functions for dramatic makeup styles with high-frequency details. Existing techniques do not demonstrate or fail to transfer high-frequency details in a global adversarial setting, or train a single local discriminator only to ensure image structure consistency and thus work only for relatively simple styles. Unlike others, our proposed local adversarial discriminators can distinguish whether the generated local image details are consistent with the corresponding regions in the given reference image in cross-image style transfer in an unsupervised setting. Incorporating these technical contributions, we achieve not only state-of-the-art results on conventional styles but also novel results involving complex and dramatic styles with high-frequency details covering large areas across multiple facial features. A carefully designed dataset of unpaired before and after makeup images will be released.
          </p>
        </div>
      </div>

    </div>

    <div class="jumbotron" id="result">
      <h2>Qualititive Results</h2>
      <br />
      <h6><b>Source</b>: an image of clean face without cosmetic makeup</h6>
      <h6><b>Reference</b>: another image of an after-makeup face</h6>
      <h6><b>Makeup transfer</b>: synthesize a new image where the specific makeup style from the reference is applied on the face of the source</h6>
      <h6><b>Makeup Removal</b>: Recover the natural face of the reference after removing the makeup</h6>

      <hr />
      <h3>Makeup Transfer Results</h3>
      <br />

      <div class="row">
        <div class="col-sm-2 offset-sm-3">
          <h5>Source</h5>
        </div>
        <div class="col-sm-2">
          <h5>Reference</h5>
        </div>
        <div class="col-sm-2">
          <h5>Results</h5>
        </div>
      </div>

      <div class="row margintd10" v-for="index in makeup_list">
        <div class="col-sm-2 offset-sm-3">
          <img :src="'public/transfer/'+index+'_before.jpg'" style="width:90%"/>
        </div>
        <div class="col-sm-2">
          <img :src="'public/transfer/'+index+'_after.jpg'" style="width:90%"/>
        </div>
        <div class="col-sm-2">
          <img :src="'public/transfer/'+index+'_transfer.jpg'" style="width:90%"/>
        </div>
      </div>

    </div>

    <div class="jumbotron bg-white">
      <h3>Makeup removal Results</h3>
      <br />
      <div class="row">
        <div class="col-sm-2 offset-sm-2">
          <h5>Reference</h5>
        </div>
        <div class="col-sm-2">
          <h5>Results</h5>
        </div>
        <div class="col-sm-2">
          <h5>Reference</h5>
        </div>
        <div class="col-sm-2">
          <h5>Results</h5>
        </div>
      </div>

      <div class="row margintd10" v-for="two in removal_list">
        <div class="col-sm-2 offset-sm-2">
          <img :src="'public/removal/'+two[0]+'_reference.jpg'" style="width:90%"/>
        </div>
        <div class="col-sm-2">
          <img :src="'public/removal/'+two[0]+'_demakeup.jpg'" style="width:90%"/>
        </div>
        <div class="col-sm-2">
          <img :src="'public/removal/'+two[1]+'_reference.jpg'" style="width:90%"/>
        </div>
        <div class="col-sm-2">
          <img :src="'public/removal/'+two[1]+'_demakeup.jpg'" style="width:90%"/>
        </div>

      </div>

    </div>

    <div class="jumbotron">
      <h3>Interpolation Results</h3>
      <br />

      <div class="row" v-for="two in interpolation_list">
        <div class="col-sm-3 offset-sm-3">
          <div class="row margintd10">
            <div class="col-sm-12">
              <img :src="'public/interpolation/'+two[0]+'/transfer.gif'"  width="100%"/>
              <h6>Interpolated Makeup Styles</h6>
            </div>
          </div>
          <div class="row margintd10">
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+two[0]+'/afterA.jpg'"  width="100%"/>
              <h6>Ref 1</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+two[0]+'/before.jpg'"  width="100%"/>
              <h6>Source</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+two[0]+'/afterB.jpg'"  width="100%"/>
              <h6>Ref 2</h6>
            </div>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="row margintd10">
            <div class="col-sm-12">
              <img :src="'public/interpolation/'+two[1]+'/transfer.gif'"  width="100%"/>
              <h6>Interpolated Makeup Styles</h6>
            </div>
          </div>
          <div class="row margintd10">
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+two[1]+'/afterA.jpg'"  width="100%"/>
              <h6>Ref 1</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+two[1]+'/before.jpg'"  width="100%"/>
              <h6>Source</h6>
            </div>
            <div class="col-sm-4">
              <img :src="'public/interpolation/'+two[1]+'/afterB.jpg'"  width="100%"/>
              <h6>Ref 2</h6>
            </div>
          </div>
        </div>
      </div>


    </div>

    <!-- <div class="jumbotron bg-white" id="network">
      <h2>Network Architectures</h2>

      <hr />
      <h3>Content-Style Disentangling Network</h3>
      <center>
        <img src="public/network_whole.png" style="width:40%"/>
      </center>

      <div class="row">
        <div class="col-sm-8 offset-sm-2">
          <p class="text-align-left">
            We use a content-style disentangling network as our network backbone. We define attribute space $A$ that captures the makeup style latent and content space $S$ which includes the non-makeup features, and our network is composed of
            content encoders $\{ E^c_X, E^c_Y\}$,
            style encoders $\{ E^a_X, E^a_Y\}$
            and generators $\{ G_X, G_Y\}$.

            As shown in the above figure, by
            $E^a_X(x_i) = A_i$, $E^a_Y(y_j) = A_j$ and
            $E^c_X(x_i) = C_i$, $E^c_Y(y_i) = C_j$,
            we capture the attribute and content from a source image and a makeup reference, which are then fed into the generators to generate the de-makeup result $\tilde{x}_j$ and makeup transfer result $\tilde{y}_i$:

            $$G_X(A_i, C_j) = \tilde{x}_j \textrm{ and } G_Y(A_j, C_i) = \tilde{y}_i.$$
          </p>
        </div>
      </div>

      <hr />
      <h3>Local Discriminator Network</h3>
      <center>
        <img src="public/network_local.png" style="width:80%"/>
      </center>

      <div class="row">
        <div class="col-sm-8 offset-sm-2">
          <p class="text-align-left">
            Given a set of $K$ local discriminators $\{D^{local}_k\}_{k=1,\cdots, K}$ at each facial landmark, a local patch from the makeup reference $p^{Y}_k$ (a), the corresponding local patch from makeup warp $p^{W}_k$ (b), and that from the generated facial image $\tilde{p}_k^Y$ (c) are cropped and fed into the local discriminator $D^{local}_k$ in pairs. By setting the ground truth for different pairs to local discriminators, the local discriminators will learn to judge $p^{Y}_k$ and $p^{W}_k$ as positive pairs (of the same makeup style), and judge $p^{Y}_k$ and $\tilde{p}_k^Y$ as negative pairs (of different makeup styles).
            Meanwhile, the goal of the generator $\Phi_Y$ is to generate the result $\tilde{y}_i$ which is of the same makeup style as the makeup reference $y_j$, therefore forming an adversarial learning process with the local discriminators. The loss for local discriminators is $L^{local}=\sum_k L^{local}_k$, where $L^{local}_k$ is defined as
            \begin{equation} \label{local_loss}
            \begin{split}
                L^{local}_k
                =&\mathbb{E}_{x_i\sim P_X, y_j\sim P_{Y}}
                [\log D^{local}_k(p_k^Y, p_k^W)]\\
                +&\mathbb{E}_{x_i\sim P_X, y_j\sim P_{Y}}
                [\log [1-D^{local}_k(p_k^Y, \tilde{p}_k^Y)].
            \end{split}
            \end{equation}

            The corresponding mini-max game is defined as
            \begin{equation}
                \min_{D^{local}_k}
                \max_{E^c_X, E^a_Y, G_Y}
                L^{local}.
            \end{equation}

            By this setup, we take the synthetic results as guidance and encourage the local discriminators to capture makeup details from the makeup reference.
          </p>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      makeup_list: [1,3,26,6,43,47,50,65],
      removal_list: [[1,2], [3,4], [5,6], [7,8]],
      teaser_list: [11,1],
      interpolation_list: [[3,4], [5,6], [7,8], [9,2]]
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 40px;
}

hr {
  margin-top: 30px;
  margin-bottom: 30px;
}

.jumbotron p {
  margin-bottom: 15px;
  font-size: 21px;
  font-weight: 200;
}

.margintd10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.text-align-left {
  text-align: left;
}

.img-width-auto {
  img {
    width: 100%;
  }
}

.bg-white {
  background: white;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

// a {
//   color: #42b983;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue